export function getCountry(countryCode: string) {
  if (!countryCode) return null;
  const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });

  return regionNames.of(countryCode);
}
